<template>
	<div style="overflow: hidden; min-height: 600px;">
		<div class="search-box">
			<Input v-model="params.title" search :placeholder="lang == 'zh' ? '请输入要搜索的内容' : 'Please enter what you want to search for'" style="width: 390px; margin-left: 30%; height: 27px; line-height: 27px; border-radius: 0; margin-top: 6px; color: #1059BF; font-size: 14px;"/>
			<div class="search-button" @click="toSearch">
				{{lang == 'zh' ? '搜索' : 'Search'}}
			</div>
		</div>
		<div class="collection-block">
			<div class="search-block-top" v-if="isSearch">
				<span v-if="lang == 'zh'">
					找到约{{count}}条结果（用时{{((end - start) / 1000).toFixed(2)}}秒）  每页显示10条搜索结果
				</span>
				<span v-else>
					About {{count}} results are found ({{((end - start) / 1000).toFixed(2)}} seconds) and 10 search results are displayed per page
				</span>
			</div>
			<div class="collection-main">
				<div class="collection-box" v-for="(item, index) in newsList" :key="index">
					<!-- <img :src="$imgUrl + item.listImgPc" alt=""> -->
					<div class="search-box-top">
						<div v-html="changeKeyRed(item.title)" class="search-box-top-title"  @click="toDetails(item.id)">

						</div>
						<div class="search-box-top-time">
							{{$moment(item.createdTime).format('YYYY/MM/DD')}}
						</div>
					</div>
					<div class="search-box-bottom" v-html="item.content">
						<!-- {{item.content}} -->
					</div>
				</div>
			</div>
			<page :pageObj="params" :startSearch="false" @getDataList="getDataList" ref="page"></page>
		</div>
	</div>
</template>

<script>
	import Page from '@/components/Page.vue'
	export default {
		name: '',
		components: {
			Page,
		},
		data () {
			return {
				params: {
					current: 1,
					size: 10,
					title: '',
					isDisplay: "1",
					siteId: 1
				},
				newsList: [],
				start: 0,
				end: 0,
				count: 0,
				isSearch: false
			}
		},
		mounted() {
			let that = this
			that.$store.state.firstSelect = ''
			that.$store.state.secondSelect = ''
			that.$store.state.secondList = []
			that.$store.state.channelId = ''
			that.$store.state.showTopImage = true
			that.$store.state.topImage = '../../../static/search_top.png'
		},
		computed: {
			lang() {
				return this.$store.state.lang
			}
		},
		methods: {
			getDataList(dataList, count) {
				this.end = Date.now()
				this.isSearch = true
				this.newsList = dataList
				this.newsList.forEach(item => {
					var content = item.txt
					// if (content != null && content != '') {
					// 	var reg = /[\u4e00-\u9fa5]/g
					// 	var names = content.match(reg)
					// 	var val = names.join('')
					// 	item.content = val.substr(0, 500);//获取富文本文字内容的前50个字符
					// }
					var re1 = new RegExp("<.+?>","g");//匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
					var msg = content.replace(re1,'');//执行替换成空字符
					var msg = msg.replace('no video', '。')
					item.content = msg.substr(0, 500);

				})
				this.count = count
			},
			toDetails(news_id) {
				this.$router.push({
					path: '/gnzx_xqy',
					query: {
						news_id: news_id
					}
				})
			},
			toSearch() {
				if(!this.params.title) {
					this.$Message.error('请输入要搜索的内容')
					return
				}
				this.start = Date.now()
				this.params.current = 1
				this.$refs.page.getData()
			},
			changeKeyRed(str) {
				var keyWord = this.params.title
				if(str!=null&&keyWord!=null){
					var substr="/"+keyWord+"/g";
					var replaceStr=str.replace(eval(substr),"<span style='color: #A21C2A;'>"+keyWord+"</span>")
					return replaceStr;
				}
				else {
					return str;
				}
			}

		}
	}
</script>

<style lang="less" scoped>
	.search-box {
		width: 100%;
		height: 45px;
		background-color: #D0DEFD;
		display: flex;
		.search-button {
			width: 90px;
			height: 30px;
			line-height: 30px;
			margin: 7px 0 0 15px;
			background-color: #264EA7;
			color: #FFFFFF;
			font-size: 14px;
			cursor: pointer;
		}
	}
	.collection-block {
		width: 74%;
		margin: 0 13%;
		padding: 20px 0 40px;
		.search-block-top {
			font-size: 15px;
			color: #686868;
			text-align: left;
			padding: 20px 0 10px;
			border-bottom: 2px solid #264EA7;
		}
		.collection-main {
			width: 100%;
			display: flex;
			flex-direction: column;
			margin-top: 30px;
			.collection-box {
				width: 100%;
				padding: 14px 24px;
				border: 1px solid #264EA7;
				margin-bottom: 20px;
				.search-box-top {
					display: flex;
					justify-content: space-between;
					.search-box-top-title {
						color: #264EA7;
						font-size: 16px;
						text-decoration: underline;
						cursor: pointer;
						overflow: hidden;
						white-space: nowrap;
						text-overflow: ellipsis;
					}
					.search-box-top-time {
						color: #686868;
						font-size: 16px;
					}
				}
				.search-box-bottom {
					margin-top: 30px;
					color: #686868;
					font-size: 13px;
					text-align: left;
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-line-clamp: 3;
					line-clamp: 3;
					-webkit-box-orient: vertical;
				}
			}
		}

	}
</style>



// WEBPACK FOOTER //
// src/views/search/search.vue